import React, { useState } from 'react'
import { Box, Grid, Card, Flex, Text, Group, ThemeIcon, NumberFormatter, Button, SimpleGrid, Anchor, Image, Badge, Modal } from '@mantine/core'
import { useSelector } from 'react-redux'
import { IconPackages, IconPackage, IconBox } from '@tabler/icons-react'
import { checkUrl } from '../../../../plugins/checkUrl'
import FormAdjustDropship from './Form/FormAdjustDropship'

const OrderDropshipInfo = () => {
  const { isLoadingOrder, general, dropship } = useSelector(state => state.order_detail)
  const [openModalDropship, setOpenModalDropship] = useState(false)

  const profitCount = (general) => {
    if (general.totalPrice > 0) {
      return general.totalPrice - general.grandTotal
    } else {
      return general.grandTotal
    }
  }

  const openLink = (url) => {
    const link = checkUrl(url)
    if (link) {
      window.open(`${link}`, '_blank')
    }
  }

  const onCloseModalDropship = () => {
    setOpenModalDropship(false)
  }

  return (
    <Box>
      <Box my={20}>
        <Grid align='start' overflow='hidden'>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md' h={383}>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='flex-start' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="white" size='lg'>
                      <IconPackages style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500}>Ordered on Platform / Dropship</Text>
                  </Group>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconBox style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>Dropship / Platform's Grand Total</Text>
                  </Group>
                  <Box>
                    <Text fz={14} fw={500} c='blue.8'> <NumberFormatter prefix={`${!isLoadingOrder ? general.orderCurrency : '-'} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? general.totalPrice : 0} /></Text>
                  </Box>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py="xs" h={400}>
                <Flex justify='space-between' align='center'>
                  <Group align='center' gap='xs'>
                    <ThemeIcon variant="light" color="blue" radius='xl'>
                      <IconPackage style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                    <Text fz={14} fw={500} c='gray.8'>AsiaCommerce'e Grand Total</Text>
                  </Group>
                  <Box>
                    <Text fz={14} fw={500} c='blue.8'> <NumberFormatter prefix={`${!isLoadingOrder ? general.orderCurrency : '-'} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? general.grandTotal : 0} /></Text>
                  </Box>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding>
                <Box my={8}>
                  <Flex Flex justify='space-between' align='flex-start'>
                    <Group align='center' gap='xs'>
                      <Text fz={14} fw={500} c='gray.7'>Profit</Text>
                    </Group>
                    <Box>
                      <Text fz={14} fw={500}> <NumberFormatter prefix={`${!isLoadingOrder ? general.orderCurrency : '-'} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={!isLoadingOrder ? profitCount(general) : 0} /></Text>
                    </Box>
                  </Flex>
                </Box>
              </Card.Section>
            </Card>
          </Grid.Col>
          <Grid.Col span={6}>
            <Card withBorder shadow="xs" radius="md" padding='md'>
              <Card.Section withBorder inheritPadding py="xs">
                <Flex justify='flex-end' align='center' py={6}>
                  <Button size='compact-xs' variant="outline" color='black' onClick={() => setOpenModalDropship(true)}>Edit</Button>
                </Flex>
              </Card.Section>
              <Card.Section withBorder inheritPadding py='md'>
                <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
                  <Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={2}>Sender Name</Text>
                      <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? dropship.senderName || '-' : '-'}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={2}>No. Order/Inv</Text>
                      <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? dropship.orderNo || '-' : '-'}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={2}>Courier</Text>
                      <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? dropship.platform.shippingCourier || '-' : '-'}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={2}>AWB Number</Text>
                      <Text fz={12} c='black' fw='600'>{!isLoadingOrder ? dropship.platform.trackingNumber || '-' : '-'}</Text>
                    </Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={2}>Shipping Label</Text>
                      <Anchor fz={12} underline="hover" onClick={!isLoadingOrder ? () => openLink(dropship.platform.shippingDocument) : '' }  c={!isLoadingOrder ? dropship.platform.shippingDocument ? 'blue' : 'gray' : 'gray'} fw='500'>{!isLoadingOrder ? dropship.platform.shippingDocument ? 'Download' : 'Seller Has Not Arranged Delivery' : ''}</Anchor>
                    </Box>
                  </Box>
                  <Box>
                    <Box mb='md'>
                      <Text fz={12} c='gray.6' mb={10}>Platform</Text>
                      {!isLoadingOrder ? dropship.platform.name ? <Image w='auto' h={35} mb={8} fit="contain" src={require(`../../../../assets/img/platform/${dropship.platform.name.toLowerCase() + '.svg'}`)} /> : '-' : '-'}
                      {!isLoadingOrder ? dropship.platform.name ? <Badge variant="light" color='black' tt='capitalize' fw='500' >{dropship.platform.name}</Badge> : '' : ''}
                    </Box>
                  </Box>
                </SimpleGrid>
              </Card.Section>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    <Modal opened={openModalDropship} onClose={onCloseModalDropship} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Edit Dropship Info</Text>} withCloseButton={false}>
      <FormAdjustDropship onCloseForm={onCloseModalDropship} />
    </Modal>
    </Box>
    
  )
}

export default OrderDropshipInfo